module.exports = __webpack_public_path__ + "static/media/logout.993992e2.svg";